/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Explorer_HintInputs */

const en_us2_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 different exercises`)
};

const pt_br2_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 exercícios diferentes`)
};

const es_419_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 ejercicios diferentes`)
};

const pt_pt2_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 exercícios diferentes`)
};

const fr_fr2_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 exercices différents`)
};

const de_de2_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 verschiedene Übungen`)
};

const it_it2_achievement_explorer_hint = /** @type {(inputs: Achievement_Explorer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 esercizi diversi`)
};

/**
* | output |
* | --- |
* | "20 different exercises" |
*
* @param {Achievement_Explorer_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_explorer_hint = /** @type {((inputs?: Achievement_Explorer_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Explorer_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_explorer_hint(inputs)
	if (locale === "es-419") return es_419_achievement_explorer_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_explorer_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_explorer_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_explorer_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_explorer_hint(inputs)
	return en_us2_achievement_explorer_hint(inputs)
});
export { achievement_explorer_hint as "achievement.explorer_hint" }